<template>
	<div class='media-container'>
		<div class='media_container'>
			<div class='media'
				v-for="(md, m) in mediaPhoto"
				:key='"mediaPhoto"+m'
			>
				<MediaSlot v-model='mediaPhoto[m]'
					v-if="mediaPhoto[m].file"
					:ref='`mediaSlot-${m}`'
					@photo-added='addMedia()'>
					<div class='imageWrapper'>
						<img :src='mediaPhoto[m].file.file'>
					</div>
				</MediaSlot>
				<div class='delete-btn' @click='delMediaPhoto(m)'>
					<svg class='icon'>
						<use xlink:href='#icon-remove'/>
					</svg>
				</div>
			</div>
		</div>
		<div class='media_container-file' v-if="mediaFile.length > 0">
			<div class='attachment-file'
				v-for="(md, m) in mediaFile"
				:key='"attachment-file"+m'
			>
				<div class='fileWrapper' v-if='mediaFile[m].file'>
					<div class="file-content" v-if='mediaFile[m].file'>
						<svg class='icon'>
							<use v-if="['xls', 'xlsx', 'XLS', 'XLS'].includes(md.file.format)" xlink:href='#icon-file-excel'  style="color: green;"/>
							<use v-if="['doc', 'docx', 'DOC', 'DOCX'].includes(md.file.format)" xlink:href='#icon-file-word' style="color: blue;"/>
							<use v-if="['pdf'].includes(md.file.format)" xlink:href='#icon-file-pdf' style="color: red;"/>
						</svg>
						<div>
							<p class="file-name">{{ mediaFile[m].file.name }}</p>
							<p class="file-error" v-if="errors[m]" >( {{ errors[m]}} )</p>
							<div class='delete-btn' @click='delMediaFile(m)'>
								<svg class='icon'>
									<use xlink:href='#icon-remove'/>
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>
			<br>
		</div>
		<slot></slot>
	</div>
</template>

<script>
import MediaSlot from '__jsVueSections/MediaSlot/MediaSlot.vue';

export default {
	name:       'MediaContainerFile',
	components: {
		MediaSlot
	},
	props: {
		value: {
			type: Array,
			default() {
				return [];
			}
		},
		maxLength: {
			type:    Number,
			default: 5
		},
		page: {
			type:    String,
			default: 'media-container'
		},
		hideButtonAdd: {
			type:    Boolean,
			default: false
		},
		errors: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data: function() {
		return {
			media: false,
		};
	},
	created: function() {
		this.media = this.value;
	},
	watch: {
		media: {
			handler(newVal) {
				this.$emit('input', newVal);
			},
			deep: true
		},
		value: function() {
			this.media = this.value;
		}
	},
	computed: {
		mediaPhoto() {
			return this.media.filter(file => ![
				'xls', 'xlsx', 'XLS', 'XLS', 'doc', 'docx', 'DOC', 'DOCX', 'pdf'
			].includes(file.file.format));
		},
		mediaFile() {
			return this.media.filter(file => [
				'xls', 'xlsx', 'XLS', 'XLS', 'doc', 'docx', 'DOC', 'DOCX', 'pdf'
			].includes(file.file.format));
		},
	},
	methods: {
		addMedia: function() {
			this.media.push({
				id:    false,
				image: {
					src:  false,
					blob: false
				}
			});
			if (this.media.length === 1) {
				setTimeout(() => {
					this.$refs[`mediaSlot-${this.media.length - 1}`][0].openExplorer();
				}, 100);
			}
		},
		delMediaPhoto: function(m) {
			var mediaPhoto = this.media.filter(file => ![
				'xls', 'xlsx', 'XLS', 'XLS', 'doc', 'docx', 'DOC', 'DOCX', 'pdf'
			].includes(file.file.format));
			var delMediaFile = this.media.filter(file => [
				'xls', 'xlsx', 'XLS', 'XLS', 'doc', 'docx', 'DOC', 'DOCX', 'pdf'
			].includes(file.file.format));
			mediaPhoto.splice(m, 1);
			this.media = [...mediaPhoto, ...delMediaFile ?? []];
			this.$emit('delete', true);
		},
		delMediaFile: function(m) {
			var mediaPhoto = this.media.filter(file => ![
				'xls', 'xlsx', 'XLS', 'XLS', 'doc', 'docx', 'DOC', 'DOCX', 'pdf'
			].includes(file.file.format));
			var delMediaFile = this.media.filter(file => [
				'xls', 'xlsx', 'XLS', 'XLS', 'doc', 'docx', 'DOC', 'DOCX', 'pdf'
			].includes(file.file.format));
			delMediaFile.splice(m, 1);
			this.media = [...delMediaFile, ...mediaPhoto ?? []];
			this.$emit('delete', true);
		},
	}
};
</script>
